import axios, { AxiosError, AxiosInstance } from 'axios'
import { getApp } from '@/main'

export const attachAxiosErrorNotificationInterceptor = (
  instance: AxiosInstance
) => {
  instance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      if (axios.isCancel(error)) {
        return Promise.reject(error)
      }

      const customConfig = error?.config || {}
      const status = error.response?.status || 0
      const method = error.config.method?.toLowerCase()
      const isShowNotify = customConfig?.isShowNotify ?? true

      if (!isShowNotify) return Promise.reject(error)

      // Проверка на 403 для метода PUT и показ сообщения
      if (method === 'put' && status === 403) {
        getApp.then((app) => {
          app.$notify({
            type: 'error',
            title: 'У вас нет доступа на редактирование раздела',
          })
        })
      }

      const errors = error?.response?.data as
        | Record<string, string[]>
        | undefined

      if (errors) {
        let errorText = ''

        if (Array.isArray(errors.message) && errors.message.length) {
          errorText = errors.message[0]
        } else if (typeof errors.message === 'string') {
          errorText = errors.message
        } else {
          const [firstErrorKey] = Object.keys(errors)

          const firstErrorMessage =
            firstErrorKey &&
            Array.isArray(errors[firstErrorKey]) &&
            errors[firstErrorKey][0]

          errorText = firstErrorMessage || errorText
        }

        if (errorText) {
          getApp.then((app) => {
            app.$notify({
              type: 'error',
              title: errorText,
            })
          })
        }
      }

      return Promise.reject(error)
    }
  )
}
